import {onBlockLoaded} from "@plaudit/frontend-apis";

function dialogModeIsDisabled(wrapper: Element) {
	const content = getComputedStyle(wrapper, ':before').content;
	return content.length > 2 && content.substring(1, content.length - 1) === 'not-dialog';
}

function updateDialogMode(wrapper: Element) {
	const dialog = wrapper.querySelector("dialog");
	if (dialog) {
		const dialogModeDisabled = dialogModeIsDisabled(wrapper);
		if (dialogModeDisabled) {
			dialog.close();
		} else {
			dialog.ariaExpanded = dialog.open.toString();
		}
		wrapper.classList.toggle("dialog-mode-disabled", dialogModeDisabled);
	}
}

onBlockLoaded("plaudit-base/generic-dialog", wrapper => {
	const dialog = wrapper.querySelector("dialog");
	if (dialog) {
		updateDialogMode(wrapper);
		dialog.addEventListener('close', () => dialog.ariaExpanded = dialogModeIsDisabled(wrapper).toString());
	}
});

function debounce<T extends any[]>(this: void, func: (...args: T) => void, delay?: number, immediate = false): typeof func {
	let timerId: ReturnType<typeof setTimeout>|undefined = undefined;
	return (...args: T) => {
		const boundFunc = func.bind<void, T, [], void>(this, ...args);
		clearTimeout(timerId);
		if (immediate && !timerId) {
			boundFunc();
		}
		const calleeFunc = immediate ? () => { timerId = undefined } : boundFunc;
		timerId = setTimeout(calleeFunc, delay);
	};
}

window.addEventListener('resize', debounce(() => document.querySelectorAll(".wp-block-plaudit-base-generic-dialog").forEach(updateDialogMode)));
